blist.namespace.fetch('blist.events');

blist.events.MODAL_SHOWN = 'modalshown';
blist.events.MODAL_HIDDEN = 'modalhidden';
blist.events.DISPLAY_ROW = 'displayrow';
